import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  show: false,
};
const overlaySlice = createSlice({
  name: "overlay",
  initialState,
  reducers: {
    openOverlay: (state) => {
      state.show = true;
    },
    closeOverlay: (state) => {
      state.show = false;
    },
  },
});

export const { openOverlay, closeOverlay } = overlaySlice.actions;

export default overlaySlice.reducer;
